module.exports = {"name":{"ja":"イベント名","en":"Event Name"},"settlement":{"ja":"※決済がお済みの方","en":"※Payment Complete"},"link":{"ja":"アプリ連携","en":"Sync App to the Event"},"question":{"ja":"FAQ","en":"FAQ"},"howtojoin":{"ja":"HowToJoin","en":"HowToJoin"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/constants/event/event.json
// module id = HLJT
// module chunks = 1